import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PRODUCT_TYPES } from '@moal/api'
import { useContext } from 'react'
import { SiteConfigContext } from '../../../context/siteConfigContext'

const PolicyViewer = ({ fieldKey }) => {
  const { productsService } = useContext(SiteConfigContext)

  if (!productsService)
    return (
      <div className="flex justify-center items-center h-screen bg-white p-8 prose mx-auto">
        <FontAwesomeIcon icon={faSpinner} spin size="3x" />
      </div>
    )

  const policies = productsService[PRODUCT_TYPES.ORG].policies || {}
  const content = policies[fieldKey] || { url: '', html: '' }

  if (content.url) {
    return (
      <div className="flex h-full w-full flex-col">
        <iframe
          className="h-full w-full min-h-[400px]"
          src={content.url}
        ></iframe>
      </div>
    )
  } else if (
    content.html !== null &&
    content.html !== '' &&
    content.html !== '<p><br></p>'
  ) {
    return (
      <div
        className="h-full p-4 mx-auto prose dark:prose-invert"
        dangerouslySetInnerHTML={{ __html: content.html }}
      />
    )
  }

  return (
    <div className="flex flex-col gap-4 container mx-auto mb-auto p-2 md:py-10">
      <h2>Please reach out to the Moderators for support.</h2>
    </div>
  )
}

export default PolicyViewer
